import { shouldSkipShortcut } from '@/lib/keyboard'
import { isModalOpen } from '@/lib/overlayLayers'
import { useShortcut } from '@/lib/useShortcut'
import { useCallback } from 'react'
import { useCommandPaletteStore } from './commandPaletteStore'

/**
 * A key an editor already handled (the rich text link shortcut) arrives here defaultPrevented and is
 * left alone. While another modal is open the shortcut does nothing, so a half filled form is never
 * stacked under the palette. Once the palette is open, its own list claims Mod+K as "previous item",
 * so only a held key is ignored then — every other guard is for deciding whether to open it.
 */
export function useCommandPaletteShortcut() {
	const onToggle = useCallback((event: KeyboardEvent) => {
		const { isOpen, setOpen } = useCommandPaletteStore.getState()
		const skip = isOpen ? event.repeat : shouldSkipShortcut(event, { inTextFields: true }) || isModalOpen()
		if (skip) {
			return
		}
		event.preventDefault()
		setOpen(!isOpen)
	}, [])
	useShortcut('palette.toggle', onToggle, { skipDefaultGuards: true })
}
